<template>
  <div>
    <div style="margin-bottom: 15px;">
      <div style="float:left;width:20%;">
        <img src="../../../assets/show/index_m2.jpg" />
      </div>
      <div style="float:right;width:80%;padding-left:38px">
        <div style="clear:both"></div>
        <div class="divleft">
          <a-button class="showThreeBtn">
            <div style="float:left"><a-icon type="setting" />价格行情</div>
          </a-button>
          <div>
            <a-button class="showThreeBtnl" @mouseenter="VegetablePriceEnter" >价格行情</a-button>
            <a-button class="showThreeBtnl" @mouseenter="RawPriceEnter">原料价格</a-button>
          </div>
          <div>
            <a-list bordered :data-source="loadData2">
              <a-list-item v-for="(item, index) of loadData2.slice(0, 5)" :key="index" :value="item.title">
                <a @click="PriceClick(item.id)" style="color:#000">
                  <span style="float:left">{{ item.title }}</span>
                </a>
                <a @click="PriceClick(item.id)" style="color:#000">
                  <span style="float:right">{{ item.publishTime|moment('MM-DD') }} </span>
                </a>
              </a-list-item>
            </a-list>
          </div>
        </div >
        <div class="divright">
          <a-button class="showThreeBtn">
            <span style="float:left"><a-icon type="setting" />供求信息</span>
            <a><span style="float:right"><a-icon type="file-done" />发布</span></a>
          </a-button>
          <div>
            <a-button class="showThreeBtns" @mouseenter="SupplyEnter">供应信息</a-button>
            <a-button class="showThreeBtns" @mouseenter="DemandEnter">求购信息</a-button>
          </div>
          <div>
            <a-list bordered :data-source="loadData">
              <a-list-item v-for="(item, index) of loadData.slice(0, 5)" :key="index" :value="item.title">
                <a @click="TextcontentClick(item.id)" style="color:#000">
                  <span style="float:left">{{ item.sdTitle }}</span>
                </a>
                <a @click="TextcontentClick(item.id)" style="color:#000">
                  <span style="float:right">{{ item.publishDate|moment('MM-DD') }} </span>
                </a>
              </a-list-item>
            </a-list>
          </div>
        </div>
        <div style="clear:both"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { InfoMainWebPage } from '@/api/main/InfoMainManage'
import { SupplyAndDemandInfoWebPage } from '@/api/main/SupplyAndDemandManager'
export default {
  data() {
  return {
  SdType: '',
  SupplyData: [],
  DemandData: [],
  VegetablePriceData: [],
  RawPriceData: [],
  loadData: [],
  loadData2: [],
  Supplyisfull: false,
  Demandisfull: false,
  VegetablePriceisfull: false,
  RawPriceisfull: false

  }
  },
    created() {
    this.SupplyEnter()
    this.VegetablePriceEnter()
  },
  methods: {
    SupplyEnter() {
      this.SdType = 1
      if (this.Supplyisfull) {
        this.loadData = this.SupplyData
      } else {
        SupplyAndDemandInfoWebPage({ SdType: this.SdType }).then(res => {
        this.SupplyData = ''
        this.SupplyData = res.data.rows
        this.loadData = this.SupplyData
      })
      this.Supplyisfull = true
      }
    },
    DemandEnter() {
      this.SdType = 2
      if (this.Demandisfull) {
        this.loadData = this.DemandData
      } else {
      SupplyAndDemandInfoWebPage({ SdType: this.SdType }).then(res => {
        this.DemandData = ''
        this.DemandData = res.data.rows
        this.loadData = this.DemandData
      })
        this.Demandisfull = true
      }
    },
    VegetablePriceEnter() {
      this.SdType = 8
      if (this.VegetablePriceisfull) {
        this.loadData2 = this.VegetablePriceData
      } else {
        InfoMainWebPage({ orgId: this.orgId, infoType: this.SdType }).then(res => {
        this.VegetablePriceData = ''
        this.VegetablePriceData = res.data.rows
        this.loadData2 = this.VegetablePriceData
      })
      this.SupplyisVegetablePriceisfullfull = true
      }
    },
    RawPriceEnter() {
      this.SdType = 9
            if (this.RawPriceisfull) {
        this.loadData2 = this.RawPriceData
      } else {
      InfoMainWebPage({ orgId: this.orgId, infoType: this.SdType }).then(res => {
        this.RawPriceData = ''
        this.RawPriceData = res.data.rows
        this.loadData2 = this.RawPriceData
      })
      this.RawPriceisfull = true
      }
    },
    TextcontentClick(id) {
      const go = this.$router.resolve({ path: 'Textcontent', query: { id, sytype: 'SupplyandDemand' } })
      window.open(go.href, '_blank')
    },
    PriceClick(id) {
      const go = this.$router.resolve({ path: 'Textcontent', query: { id } })
      window.open(go.href, '_blank')
    }
  }
}
</script>
<style>
.divleft{
  float: left;
  width:50%;
  height: 302px;
}
.divright{
  float: left;
  width: 50%;
  height: 302px;
}
.showThreeBtn {
  font-family: Arial;
  font-weight: 800;
  font-size: 16px;
  background: #e6dfcf;
  height: 75px;
  width: 100%;
}

.showThreeBtnl {
  font-family: Arial;
  font-weight: 800;
  font-size: 16px;
  background: #e6dfcf;
  margin: 5px 0 5px 5px;
  padding: 0;
  width: 120px;
  height: 42px;
}
.showThreeBtns {
  font-family: Arial;
  font-weight: 800;
  font-size: 16px;
  background: #e6dfcf;
  margin: 5px 0 5px 5px;
  padding: 0;
  width: 140px;
  height: 42px;
}

.ant-btn:hover {
  color: #fff;
  background: #207e63;
}
.ant-btn:focus {
  color: #fff;
  background: #207e63;
}
.ant-btn:first {
  margin-left: 200px;
}
</style>
